import React, { useState, useEffect } from 'react';
import {
  Box, Drawer, IconButton, Typography, useMediaQuery, useTheme
} from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import ExploreIcon from '@mui/icons-material/Explore';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import axios from 'axios';
import ScheduleIcon from '@mui/icons-material/Schedule';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import EventIcon from '@mui/icons-material/Event';


const API_URL = process.env.REACT_APP_API_URL;

const Platform = ({ userId, onLogout }) => {
  const [isVerified, setIsVerified] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // e.g., sm = 600px

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const checkVerification = async () => {
      if (!userId) return;

      try {
        const response = await axios.post(`${API_URL}/api/check-verification/`, {
          user_id: userId,
        });
        setIsVerified(response.data.status === 'approved');
      } catch (error) {
        console.error('Verification check failed:', error);
        setIsVerified(false);
      } finally {
        setLoading(false);
      }
    };

    checkVerification();
  }, [userId]);

  const sidebarOptions = [
    { text: 'Create', icon: <AddIcon />, route: 'create' },
    { text: 'Explore', icon: <ExploreIcon />, route: 'recommended' },
    {
      text: isVerified ? 'Hostings' : 'My Requests',
      icon: <EventIcon />,
      route: isVerified ? 'my-hosts' : 'my-requests',
    },
    {
      text: isVerified ? 'Accepted' : 'My Bookings',
      icon: <LiveTvIcon />,
      route: isVerified ? 'accepted' : 'bookings',
    },
  ];

  const drawerWidth = 60;
  const drawerHeight = 60;

  const drawerStyle = {
    width: isMobile ? '100%' : drawerWidth,
    height: isMobile ? drawerHeight : '100%',
    boxSizing: 'border-box',
    backgroundColor: '#000000',
    borderTop: isMobile ? '1px solid #333' : 'none',
    borderRight: isMobile ? 'none' : '1px solid #333',
    pt: isMobile ? 0 : 8,
    display: 'flex',
    flexDirection: isMobile ? 'row' : 'column',
    alignItems: 'center',
    justifyContent: isMobile ? 'space-around' : 'flex-start',
  };

  return (
    <Drawer
      variant="permanent"
      anchor={isMobile ? 'bottom' : 'left'}
      sx={{
        width: isMobile ? '100%' : drawerWidth,
        height: isMobile ? drawerHeight : '1vh',
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: drawerStyle,
      }}
    >
      {sidebarOptions.map((option) => (
        <Link
          to={`/platform/${userId}/${option.route}`}
          key={option.text}
          style={{ textDecoration: 'none' }}
        >
          <Box
            onMouseEnter={() => setHoveredItem(option.text)}
            onMouseLeave={() => setHoveredItem(null)}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: isMobile ? 0 : 2,
              px: isMobile ? 2 : 0,
              '&:hover .text': {
                visibility: 'visible',
                opacity: 1,
              },
            }}
          >
            <IconButton
              sx={{
                color: hoveredItem === option.text ? '#1E90FF' : 'white',
                transition: 'color 0.3s ease',
              }}
            >
              {option.icon}
            </IconButton>
            {!isMobile && (
              <Typography
                className="text"
                sx={{
                  fontSize: '0.7rem',
                  color: hoveredItem === option.text ? '#1E90FF' : 'white',
                  visibility: 'hidden',
                  opacity: 0,
                  transition: 'opacity 0.3s ease',
                  textAlign: 'center',
                }}
              >
                {option.text}
              </Typography>
            )}
          </Box>
        </Link>
      ))}
    </Drawer>
  );
};

export default Platform;
